import { API_HOST } from '../config';

const BASE_URL = `${API_HOST}/api/v1/social_media/insights`;

function authHeaders() {
  return { Authorization: `Bearer ${localStorage.getItem('access')}` };
}

async function request(url) {
  const response = await fetch(url, { headers: authHeaders() });
  if (!response.ok) {
    const error = new Error('Could not read your insight status.');
    error.status = response.status;
    throw error;
  }
  return response.json();
}

/**
 * Whether we can still read this creator's own platform data.
 *
 * Shape: {youtube: {connected, status, needs_reconnect}, instagram: {...},
 * needs_reconnect}. `status` is one of unknown / ok / scope_missing /
 * token_dead / no_data / not_connected.
 */
export function getInsightsStatus() {
  return request(`${BASE_URL}/status`);
}

/** The creator's own measured audience, or nulls if we have none yet. */
export function getMyAudience() {
  return request(`${BASE_URL}/me`);
}
